import { response } from "express";
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  firstValueFrom,
  lastValueFrom,
  race,
  Subject,
  takeUntil,
  timer,
  Subscription,
  EMPTY,
} from "rxjs";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { first, map, catchError, timeout } from "rxjs/operators";
import { k } from "src/environments/properties";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { Router } from "@angular/router";
import { LoteCertificadoService } from "src/app/core/services/lote-certificado.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { CertificadoService } from "src/app/core/services/certificado.service";
import { LoteService } from "src/app/core/services/lote.service";
import { FirmaService } from "src/app/shared/data/services/firma.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { DetalleFinalizadosService } from "src/app/core/services/detalle-finalizados.service";
import { LoadingService } from "src/app/core/services/loading.service";
import { DownloadService } from "src/app/core/services/download.service";
import { Lote } from "src/app/models/Lote.model";
import { LoteCertificado } from "src/app/models/LoteCertificado.model";
import { Certificado } from "src/app/models/Certificado.model";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { ShareService } from "src/app/core/services/share.service";
import * as JSZip from "jszip";

@Component({
  selector: "app-solicitud-firma",
  templateUrl: "./solicitud-firma.component.html",
  styleUrls: ["./solicitud-firma.component.css"],
})
export class SolicitudFirmaComponent implements OnInit, OnDestroy {
  solicitudForm!: FormGroup;
  showPassword: boolean = false;
  showPin: boolean = false;
  public certificado = [];
  private idLote: any = null;
  public id_lote_estado_certificado: number;
  public loteCertificados: LoteCertificado[] = [];
  public allcertificados: LoteCertificado[] = [];
  public lote: Lote;
  public scratch: any = [];
  public new_scratch_card: any = [];
  public id_lote_certificado: number;
  public short_estado_lote: string;
  public firmaFinalizada: boolean = true;
  private loginSub?: Subscription;
  private progressSub?: Subscription;
  private doneSub?: Subscription;
  public progress: number = 0;
  public lotsCompleted: number = 0;
  public isProcessing: boolean = false;
  public creator: boolean = false;
  progressBarIsVisible: boolean = false;
  btnGuardarIsDisabled: boolean = false;
  btnUpdateScratchIsDisabled: boolean = false;
  public idStatusSigner: boolean = false;
  public restaurarIsLoagin: boolean;
  public isDiviceType: boolean = false;
  //MODAL
  public closeResult: string;
  title = "";
  changeScratchForm!: FormGroup;
  public certificados: Certificado[] = [];
  public userId: string;
  public idGrupo: number;
  public validarVencimientoCertificado: boolean = false;
  // Toast
  toast = Swal;

  firmaGrupalIndividualCompletado: boolean;
  timeoutSocketProgress: boolean;

  @Output() estadoUltimaEtapa: EventEmitter<any> = new EventEmitter<any>();

  /*Firma con imagen*/
  firmaConImagen: boolean = false;
  firmaConImagenLote: boolean = false;
  firmaGuardada: boolean = false;
  ocultarFirmaGuardada: boolean = false;
  recordarPassword: boolean = true;
  renombrarDocumentos: boolean = false;
  perGrupo: boolean = false;
  es_grupo: boolean = false;

  private destroyProgressReconect$ = new Subject<void>();
  private destroyProgressFirst$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loteCertificadoService: LoteCertificadoService,
    private certificadoService: CertificadoService,
    private firmaStateService: FirmaStateService,
    private loteService: LoteService,
    private firmaService: FirmaService,
    private webSocketService: WebsocketService,
    private detalleFinalizadosService: DetalleFinalizadosService,
    private downloadService: DownloadService,
    public loading: LoadingService,
    private modalService: NgbModal,
    private tours: HelpToursService,
    private shareService: ShareService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.toastAlert();
    this.checkDeviceType();
    this.creator = true;
    this.lote = this.firmaStateService.getCurrentState()?.lote;

    this.estadoUltimaEtapa.emit(this.lote.estado.nombre_corto);
    this.idLote = this.lote?.id;
    this.es_grupo = this.lote.es_grupo;
    this.userId = localStorage.getItem(k.user_id);
    this.renombrarDocumentos = this.lote.renombrar_documentos;

    this.solicitudForm = this.fb.group({
      scratchcard: ["", [Validators.required, this.validarVencimiento()]],
      password: ["", [Validators.required]],
      pin: ["", [Validators.required]],
      id_certificado: ["", [Validators.required]],
      autocompletar_credencial: [false, []],
      nuevo_nombre_documento: ["", []],
      perteneciente: [{ value: null, disabled: true }],
      tipo_certificado: [{ value: null, disabled: true }],
    });

    await this.creadorExist();
    await this.loteCertificado();
    await this.indexLoteCertificado();
    await this.activarFirmaImagen();
    await this.getCertificates();
    await this.nuevoNombreDoc();

    //Reconectar al socket si la pagina ha sido recargada y si es la persona que esta firmando
    if (this.id_lote_estado_certificado == 7) {
      this.reconectarSocketDelLote();
    }

    this.changeScratchForm = this.fb.group({
      id_certificado: [this.scratch?.id, [Validators.required]],
    });

    this.existPassword();
    let requestDetalleLotesFinalizados = await lastValueFrom(
      this.detalleFinalizadosService.getDetalleFinalizados(this.idLote),
    );
    if (requestDetalleLotesFinalizados?.body) {
      let detallesLoteFinalizados = requestDetalleLotesFinalizados?.body;

      //Si hay detalles pendientes (otra persona esta haciendo el proceso de firma se carga el porcentaje inicial)
      if (
        Array.isArray(detallesLoteFinalizados) &&
        detallesLoteFinalizados.length > 0
      ) {
        this.loadSpinner(detallesLoteFinalizados.length);
      }
    }

    if (
      this.id_lote_estado_certificado != 3 &&
      !this.firmaGrupalIndividualCompletado &&
      this.creator
    ) {
      this.onHelp(true);
    }
  }

  onHelp(force = false) {
    this.tours.start("firmar_documento_help", force);
  }

  loadSpinner(initial: number = 0) {
    this.lotsCompleted = initial;
    this.updateProgressbar();
  }

  updateProgressbar() {
    this.progressBarIsVisible = true;
    let newProgress = (this.lotsCompleted / this.lote.total_lotes) * 100;
    this.progress = parseFloat(newProgress.toFixed(1));
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  togglePinVisibility(): void {
    this.showPin = !this.showPin;
  }

  async guardar() {
    this.btnGuardarIsDisabled = true;
    if (this.solicitudForm.invalid) {
      this.solicitudForm.markAllAsTouched();
      this.btnGuardarIsDisabled = false;
      return;
    }

    let response = null;
    const datos = this.solicitudForm.value;

    response = await lastValueFrom(
      this.loteService.addScratch(this.idLote, datos),
    );

    if (response) {
      this.alert("success", "Credenciales enviadas correctamente");

      if (this.lote.es_grupo && this.idGrupo) {
        let data = { scratchcard: datos.scratchcard };
        await lastValueFrom(
          this.loteService.firmaElectronicaSimple(this.idLote, data),
        );

        try {
          // Prepara los streams de Socket.IO ANTES de disparar HTTP
          const loginEvent$ = this.webSocketService
            .listenForEvent(`socket-lote-${this.idLote}`)
            .pipe(first());

          // 🔥 Carrera entre el evento del socket y un timeout de 40s
          const loginOrTimeout$ = race(
            loginEvent$,
            timer(40000).pipe(map(() => ({ code: "TIMEOUT_LOGIN" }))),
          );

          // 2) Espera confirmación por socket del login
          const loginData: any = await firstValueFrom(loginOrTimeout$);

          if (loginData.code === "TIMEOUT_LOGIN") {
            // console.warn('⏰ Timeout esperando login por socket');
            // 🔥 Evitar memoria extra y sockets escuchando (por si a futuro hay subs)
            this.progressSub?.unsubscribe();
            this.alert(
              "warning",
              "Tiempo de espera agotado",
              "No se recibió confirmación del servicio, revisa que tus credenciales son correctas",
            );
            this.btnGuardarIsDisabled = false;
            return; // 🔚 ya no sigues con el flujo normal
          }

          if (loginData.code === 200) {
            if (this.recordarPassword && !this.firmaGuardada) {
              await this.putPasswordUanataca();
            }
            const loteUpdate = (await this.showLote(this.lote.id)) as Lote;
            this.firmaStateService.updateLote(loteUpdate as Lote);
            this.btnGuardarIsDisabled = false;

            this.alert(
              "success",
              "Documento firmado",
              "El documento fue firmado correctamente",
            );

            await this.indexLoteCertificados();
            await this.loteCertificado();
            await this.indexLoteCertificado();
            setTimeout(() => {
              this.validateCertificadoEstado();
            }, 2000);
          } else {
            // loginData.code !== 200
            this.btnGuardarIsDisabled = false;
            this.alert("error", "¡Alerta!", loginData.message);
            // console.log('Socket login False :(');
          }
        } catch (error) {
          this.alert(
            "error",
            "Error en el proceso de firma",
            "Intente nuevamente o contacte al administrador",
          );
          this.btnGuardarIsDisabled = false;
        }
      } else {
        await this.login();
      }
    }
  }

  async indexLoteCertificados() {
    const response = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificado(this.idLote),
    );
    this.loteCertificados = response.body as LoteCertificado[];
    this.firmaStateService.updateLoteCertificado(this.loteCertificados);
    return this.loteCertificados;
  }

  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async login() {
    // ✅ Evita doble/triple click
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    this.btnGuardarIsDisabled = true;

    // ✅ Limpia suscripciones previas, por si acaso
    this.progressSub?.unsubscribe();
    this.progressSub = undefined;

    const scratchcard = this.solicitudForm.value.scratchcard;

    try {
      // Prepara los streams de Socket.IO ANTES de disparar HTTP
      const loginEvent$ = this.webSocketService
        .listenForEvent(`socket-lote-${this.idLote}`)
        .pipe(first());

      const doneEvent$ = this.webSocketService
        .listenForEvent(`socket-lote-${this.idLote}-done`)
        .pipe(first());

      // 1) Llama al login
      const loginResponse = await firstValueFrom(
        this.firmaService.firmaLogin(scratchcard, this.idLote),
      );

      if (loginResponse.status !== 201) {
        this.btnGuardarIsDisabled = false;
        this.alert(
          "error",
          "Credenciales inválidas",
          "Verifique su usuario y contraseña e intente nuevamente",
        );

        return; // ⚠️ El finally igual se ejecuta
      }

      // 🔥 Carrera entre el evento del socket y un timeout de 40s
      const loginOrTimeout$ = race(
        loginEvent$,
        timer(40000).pipe(map(() => ({ code: "TIMEOUT_LOGIN" }))),
      );

      // 2) Espera confirmación por socket del login
      const loginData: any = await firstValueFrom(loginOrTimeout$);

      if (loginData.code === "TIMEOUT_LOGIN") {
        // 🔥 Evitar memoria extra y sockets escuchando (por si a futuro hay subs)
        this.progressSub?.unsubscribe();

        this.alert(
          "warning",
          "Tiempo de espera agotado",
          "No se recibió confirmación del servicio, revisa que tus credenciales son correctas",
        );
        this.btnGuardarIsDisabled = false;
        return; // 🔚 ya no sigues con el flujo normal
      }

      if (loginData.code === 200) {
        if (this.recordarPassword && !this.firmaGuardada) {
          await this.putPasswordUanataca();
        }
        // ──────────────────────────────
        // Caso: firma masiva (>1 documento)
        // ──────────────────────────────
        if (this.lote.total_documentos > 1) {
          const firmaMasivaResponse = await firstValueFrom(
            this.firmaService.firmaMasiva(scratchcard, this.idLote),
          );

          if (firmaMasivaResponse.status === 201) {
            this.destroyProgressFirst$.next();

            const progress$ = this.webSocketService
              .listenForEvent(`socket-lote-${this.idLote}`)
              .pipe(
                takeUntil(this.destroyProgressFirst$),
                timeout({ each: 15000 }),
                catchError(() => {
                  this.timeoutSocketProgress = true;
                  this.progressBarIsVisible = false;
                  this.progressSub?.unsubscribe();

                  this.alert(
                    "warning",
                    "Tiempo de espera agotado",
                    "No se recibió progreso en los últimos 40 segundos",
                  );

                  return EMPTY;
                }),
              );

            this.progressBarIsVisible = true;

            this.progressSub = progress$.subscribe((eventBody: any) => {
              this.lotsCompleted = eventBody.completados ?? this.lotsCompleted;
              this.updateProgressbar();

              if (eventBody.code === 200 && /login/i.test(eventBody.message)) {
              } else if (eventBody.code === 400) {
              } else if (eventBody.progress != null) {
              } else if (eventBody.status === "done") {
                this.progressBarIsVisible = false;
                this.destroyProgressFirst$.next();
                this.progressSub?.unsubscribe();
              }
            });

            // 3) Espera confirmación de 'done'
            const doneEvent: any = await firstValueFrom(doneEvent$);

            this.progressBarIsVisible = false;

            this.destroyProgressFirst$.next();
            if (doneEvent.code === 200) {
              this.firmaGrupalIndividualCompletado = true;
              this.btnGuardarIsDisabled = false;
              this.alert("success", "Documentos firmados correctamente");

              await this.validateCertificadoEstado();
            } else {
              this.alert("error", "Proceso finalizado con errores");
            }
          } else {
            this.btnGuardarIsDisabled = false;
            this.alert("error", "No se pudo iniciar la firma masiva");
          }
        } else {
          // ──────────────────────────────
          // Caso: un solo documento
          // ──────────────────────────────
          this.alert("success", "Documento firmado correctamente");
          this.btnGuardarIsDisabled = false;
          await lastValueFrom(
            this.loteCertificadoService.notificaciones(this.idLote),
          );
          await this.validateCertificadoEstado();
          await this.putLoteCertificadoEstado();

          this.estadoUltimaEtapa.emit("SDF");
        }
      } else {
        this.alert("error", "¡Alerta!", loginData.message);
        this.btnGuardarIsDisabled = false;
      }
    } catch (e) {
      this.progressSub?.unsubscribe();
      this.alert(
        "error",
        "Error en el proceso de firma",
        "Intente nuevamente o contacte al administrador",
      );
    } finally {
      // ✅ Pase lo que pase, evitamos que el botón quede muerto
      this.isProcessing = false;
      this.btnGuardarIsDisabled = false;
      this.progressBarIsVisible = false;
    }
  }

  resetProgressBar() {
    this.progress = 0;
    this.lotsCompleted = 0;
  }

  ngOnDestroy() {
    this.loginSub?.unsubscribe();
    this.progressSub?.unsubscribe();
    this.tours.stop();

    this.progressSub?.unsubscribe();
    this.doneSub?.unsubscribe();

    if (this.idLote) {
      this.webSocketService.leaveRoom(`lote-${this.idLote}`);
    }

    this.destroyProgressReconect$.next();
    this.destroyProgressReconect$.complete();

    this.destroyProgressFirst$.next();
    this.destroyProgressFirst$.complete();
  }

  async indexLoteCertificado() {
    if (this.scratch)
      if (
        this.scratch?.loteDetalleUrlCoordenada &&
        Array.isArray(this.scratch?.loteDetalleUrlCoordenada) &&
        this.scratch?.loteDetalleUrlCoordenada.length > 0 &&
        this.scratch?.loteDetalleUrlCoordenada[0].url &&
        this.scratch?.loteDetalleUrlCoordenada[0].url_base
      ) {
        //Validación para saber si el documento ya fue firmado
        if (this.id_lote_estado_certificado != 7) {
          this.firmaGrupalIndividualCompletado = true;
        }
      }

    this.idGrupo = this.scratch?.grupo ? this.scratch?.grupo?.id : null;
    this.solicitudForm.patchValue({
      scratchcard: this.scratch?.scratchcard,
      id_certificado: this.scratch?.id ? this.scratch.id : null,
      perteneciente: this.scratch?.nombre,
      tipo_certificado: this.scratch?.tipoCertificado.nombre,
    });

    const control = this.solicitudForm.get("scratchcard");

    control?.updateValueAndValidity();
    control?.markAsTouched();
    control?.markAsDirty();
  }

  async getCertificates() {
    let certificadosList = await lastValueFrom(
      this.certificadoService.getCertificados(this.userId),
    );
    if (certificadosList?.body) {
      this.certificados = certificadosList?.body;
    }
  }

  /*
     FUNCIONES PARA EL MODAL
    */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  openModal(content: any, title: string, size: string) {
    this.getCertificates();

    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", size: size })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  async putCertificado() {
    this.btnUpdateScratchIsDisabled = true;
    if (this.changeScratchForm.invalid) {
      this.changeScratchForm.markAllAsTouched();
      this.btnUpdateScratchIsDisabled = false;
      return;
    }

    const datos = this.changeScratchForm.value;

    const response = await lastValueFrom(
      this.loteCertificadoService.putCertificado(
        datos,
        this.id_lote_certificado,
      ),
    );

    if (response) {
      this.firmaGuardada = response.certificado?.existPasswordSignbox
        ? true
        : false;
      this.ocultarFirmaGuardada = this.firmaGuardada;
      this.onChangeFirmaGuardada();
      // await this.loteCertificado();
      await this.indexLoteCertificado();
      this.solicitudForm.updateValueAndValidity();
      this.solicitudForm.patchValue({
        scratchcard: this.new_scratch_card.scratchcard,
        id_certificado: this.new_scratch_card.id,
        perteneciente: this.new_scratch_card.nombre,
        tipo_certificado: this.new_scratch_card.tipoCertificado.nombre,
      });
    }

    const control = this.solicitudForm.get("scratchcard");

    control?.updateValueAndValidity();
    control?.markAsTouched();
    control?.markAsDirty();

    this.btnUpdateScratchIsDisabled = false;
  }

  async loteCertificado() {
    const response = this.firmaStateService.getCurrentState().lote_certificado;
    this.loteCertificados = response as LoteCertificado[];

    if (response) {
      this.scratch = this.loteCertificados.find((crt: any) => {
        return crt.usuario.id === this.userId;
      });

      this.new_scratch_card = this.scratch;
      if (this.scratch?.estado?.id != 6) {
        this.idStatusSigner = false;
      } else {
        this.idStatusSigner = true;
      }

      if (this.scratch) {
        const idScratch = this.solicitudForm.value.id_certificado
          ? this.solicitudForm.value.id_certificado
          : this.scratch.id;
        const response = await lastValueFrom(
          this.loteCertificadoService.loteCertificado(this.idLote, idScratch),
        );

        this.id_lote_estado_certificado = response.body.estado.id;
        this.id_lote_certificado = response.body?.id;
        this.firmaConImagen = this.scratch.usuario.firmarConImagen;
        this.firmaConImagenLote = response.body?.firmarConImagen;
      }
    }
  }

  async putLoteCertificadoEstado() {
    const datos = { estado_nombre_corto: "COMP" };
    await lastValueFrom(
      this.loteCertificadoService.putLoteCertificadoEstado(
        datos,
        this.id_lote_certificado,
      ),
    );
    await this.loteCertificado();
  }

  async allLoteCertificado() {
    const response = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificado(this.idLote),
    );
    this.allcertificados = response.body;
    return this.allcertificados;
  }

  async validateCertificadoEstado() {
    let encargado = false;

    let allCertificados = await this.allLoteCertificado();

    if (allCertificados.length > 1) {
      encargado = this.allcertificados.some((item) => item.grupo === null);
      if (encargado) {
        this.firmaFinalizada = allCertificados.some(
          (item) => item.estado?.nombre_corto === "INC",
        );
      } else {
        this.firmaFinalizada = allCertificados.some(
          (item) => item.estado?.nombre_corto === "INC",
        );
      }
    } else {
      this.firmaFinalizada = allCertificados.some(
        (item) => item.estado?.nombre_corto === "INC",
      );
    }
  }

  /*VALIDAR FIRMA GRUPAL Y TIENE UN ENCARGADO*/
  async valFirmaGrupalEncargado() {}

  async creadorExist() {
    await this.allLoteCertificado();
    const createExist = this.allcertificados.find((crt: any, index: number) => {
      return crt.usuario?.id === this.userId;
    });

    if (!createExist && this.lote?.usuario?.id != createExist?.usuario?.id) {
      this.creator = false;
    } else {
      this.creator = true;
    }
  }

  async nuevoNombreDoc() {
    if (!this.es_grupo) {
      this.solicitudForm.removeControl("nuevo_nombre_documento");
      return;
    }

    const existGrupo = this.allcertificados.find(
      (crt: any) => crt.usuario?.id === this.userId,
    );

    this.perGrupo = !!existGrupo?.grupo;

    if (!this.perGrupo) {
      this.solicitudForm.removeControl("nuevo_nombre_documento");
      return;
    }

    // Solo llega aquí si el control existe
    const control = this.solicitudForm.get("nuevo_nombre_documento");

    if (this.renombrarDocumentos) {
      control?.setValidators([Validators.required]);
    } else {
      this.solicitudForm.removeControl("nuevo_nombre_documento");
      control?.clearValidators();
    }

    control?.updateValueAndValidity();
  }

  async onNewCertificadoChange(certificado: any) {
    this.new_scratch_card = certificado;
    this.changeScratchForm.patchValue({
      id_certificado: this.new_scratch_card.id,
    });

    this.changeScratchForm.get("id_certificado")?.markAsTouched();
    this.changeScratchForm.get("id_certificado")?.updateValueAndValidity();
    // this.validarVencimiento();
    await this.putCertificado();
    // await this.indexLoteCertificados();
  }

  volverInicio() {
    this.router.navigate(["/"]); // o la ruta que quieras
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  toDateTimeLocal(utc: string): string {
    const d = new Date(utc);
    const pad = (n: number) => n.toString().padStart(2, "0");

    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
      `T${pad(d.getHours())}:${pad(d.getMinutes())}`
    );
  }

  validarVencimiento(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Evita validar en el primer render o antes del patchValue
      if (!control.value || !this.new_scratch_card?.fechaVigencia) {
        return null;
      }

      const vigencia = this.toDateTimeLocal(
        this.new_scratch_card.fechaVigencia,
      );
      const ahora = new Date();
      const fechaVigencia = new Date(vigencia);

      return ahora > fechaVigencia || !this.new_scratch_card.activo
        ? { certificadoVencido: true }
        : null;
    };
  }

  async descargarZipPorLote(nameZip: string) {
    this.downloadService
      .descargarZipPorLote(this.idLote, "mis_documentos")
      .subscribe((blob: Blob) => {
        const fileName = `${nameZip}.zip`; // o el que quieras
        const a = document.createElement("a");
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  async descargarDocumento(nameZip: string): Promise<void> {
    try {
      const blob = await firstValueFrom(
        this.downloadService.descargarZipPorLote(this.idLote, "mis_documentos"),
      );

      const zip = await JSZip.loadAsync(blob);

      const entries = Object.keys(zip.files).filter(
        (filename) => !zip.files[filename].dir,
      );

      // Más de un archivo -> descargar ZIP
      if (entries.length > 1) {
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${nameZip}.zip`;
        a.click();

        URL.revokeObjectURL(url);
        return;
      }

      // Un solo archivo -> extraer y descargar PDF
      const archivo = zip.files[entries[0]];
      const pdfBlob = await archivo.async("blob");

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const a = document.createElement("a");
      a.href = pdfUrl;
      a.download = entries[0]; // conserva el nombre original
      a.click();

      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error(error);
      this.alert("error", "Error al descargar el documento");
    }
  }

  async extraerZip(blob: Blob): Promise<File[]> {
    const MAX_FILES = 200;
    const MAX_ZIP_SIZE = 500 * 1024 * 1024; // 300 MB
    const MAX_FILE_SIZE = 85 * 1024 * 1024; // 25 MB por PDF
    const MAX_TOTAL_SIZE = 1000 * 1024 * 1024; // 1 GB total

    if (blob.size > MAX_ZIP_SIZE) {
      this.alert("error", "El archivo ZIP excede el tamaño máximo permitido");
      return [];
    }

    const zip = await JSZip.loadAsync(blob);
    const archivos: File[] = [];

    const entries = Object.keys(zip.files).filter(
      (filename) => !zip.files[filename].dir,
    );

    if (entries.length > MAX_FILES) {
      this.alert("error", "El ZIP no puede contener más de 200 documentos");
      return [];
    }

    let totalSize = 0;

    for (const filename of entries) {
      const zipEntry = zip.files[filename];

      if (
        filename.includes("..") ||
        filename.startsWith("/") ||
        filename.startsWith("\\")
      ) {
        this.alert("error", "El ZIP contiene rutas no permitidas");
        return [];
      }

      const simpleName =
        filename.split("/").pop()?.split("\\").pop() || filename;

      if (!simpleName.toLowerCase().endsWith(".pdf")) {
        this.alert("error", "El ZIP solo puede contener documentos PDF");
        return [];
      }

      const content = await zipEntry.async("blob");

      totalSize += content.size;

      if (content.size > MAX_FILE_SIZE) {
        this.alert(
          "error",
          `El archivo ${simpleName} excede el tamaño permitido`,
        );
        return [];
      }

      if (totalSize > MAX_TOTAL_SIZE) {
        this.alert(
          "error",
          "El contenido total del ZIP excede el tamaño permitido",
        );
        return [];
      }

      const file = new File([content], simpleName, {
        type: "application/pdf",
      });

      archivos.push(file);
    }

    return archivos;
  }

  async compartirPdf(nameZip: string) {
    try {
      const blob = await firstValueFrom(
        this.downloadService.descargarZipPorLote(this.idLote, "mis_documentos"),
      );
      const files = await this.extraerZip(blob);

      if (files.length === 0) return;

      const nav = navigator as any;

      // IMPORTANTE: Algunos navegadores fallan si el array es muy grande
      // Intenta primero con el primer archivo para probar si es un tema de cantidad
      const dataToShare = {
        title: "Documentos",
        text: "Te comparto los documentos",
        files: files, // Asegúrate de que sea el array de objetos File
      };

      if (nav.canShare && nav.canShare(dataToShare)) {
        await nav.share(dataToShare);
      } else {
        console.warn(
          "El navegador no permite compartir estos archivos específicos.",
        );
        this.descargarZipPorLote(nameZip);
      }
    } catch (error) {
      console.error("Error al compartir:", error);
      this.descargarZipPorLote(nameZip);
    }
  }

  DateUser(fecha: string): string {
    // Se interpreta como hora local
    const date = new Date(fecha);

    const fechaTexto = new Intl.DateTimeFormat("es-ES", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(date);

    const horaTexto = new Intl.DateTimeFormat("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(date);

    return `${fechaTexto} ${horaTexto}`;
  }

  private reconectarSocketDelLote(): void {
    if (!this.idLote) return;

    const room = `lote-${this.idLote}`;

    this.webSocketService.joinRoom(room);
    this.destroyProgressReconect$.next();

    this.progressSub?.unsubscribe();
    this.doneSub?.unsubscribe();

    this.progressSub = this.webSocketService
      .listenForEvent(`socket-lote-${this.idLote}`)
      .pipe(
        takeUntil(this.destroyProgressReconect$),
        timeout({ each: 15000 }),
        catchError(() => {
          if (this.firmaGrupalIndividualCompletado) return EMPTY;

          this.timeoutSocketProgress = true;
          this.progressBarIsVisible = false;

          this.alert(
            "warning",
            "Tiempo de espera agotado",
            "No se recibió progreso en los últimos 30 segundos",
          );

          return EMPTY;
        }),
      )
      .subscribe((eventBody: any) => {
        if (eventBody.idLote && eventBody.idLote !== this.idLote) return;

        this.lotsCompleted = eventBody.completados ?? this.lotsCompleted;
        this.updateProgressbar();

        if (eventBody.status === "done" || eventBody.progress === 100) {
          this.firmaGrupalIndividualCompletado = true;
          this.destroyProgressReconect$.next();
          this.progressSub?.unsubscribe();
        }
      });

    this.doneSub = this.webSocketService
      .listenForEvent(`socket-lote-${this.idLote}-done`)
      .subscribe((doneEvent: any) => {
        if (doneEvent.idLote && doneEvent.idLote !== this.idLote) return;
        this.progressBarIsVisible = false;
        this.destroyProgressReconect$.next();
        if (doneEvent.code === 200) {
          this.firmaGrupalIndividualCompletado = true;
          this.btnGuardarIsDisabled = false;
          this.alert("success", "Documentos firmados correctamente");
        } else {
          this.alert("error", "Proceso finalizado con errores");
        }
        this.progressSub?.unsubscribe();
        this.doneSub?.unsubscribe();
      });
  }

  async restaurarFirma() {
    this.restaurarIsLoagin = true;
    let response = await lastValueFrom(
      this.loteService.restaurarFirmaMasiva(this.lote.id, {
        id_lote_certificado: this.id_lote_certificado,
      }),
    );
    if (response?.message) {
      location.reload();
    }
    this.restaurarIsLoagin = false;
  }

  async reload() {
    location.reload();
  }

  async firmaImagen() {
    try {
      const body = { firmar_con_imagen: this.firmaConImagenLote };
      const response = await lastValueFrom(
        this.loteCertificadoService.firmarConImagen(
          body,
          this.id_lote_certificado,
        ),
      );
      this.firmaConImagenLote = response.firmarConImagen;
    } catch (error) {
      this.firmaConImagenLote = false;
    }
  }

  async putPasswordUanataca() {
    const body = { password_uanataca: this.solicitudForm.value.password };
    await lastValueFrom(
      this.certificadoService.putPasswordUanataca(
        body,
        this.changeScratchForm.value.id_certificado,
      ),
    );
  }

  onChangeFirmaImagen(valor: boolean) {
    this.firmaImagen();
  }

  async activarFirmaImagen() {
    if (!this.firmaConImagenLote) {
      if (this.firmaConImagen) {
        this.firmaConImagenLote = this.firmaConImagen;
        await this.firmaImagen();
      }
    }
  }

  onChangeFirmaGuardada() {
    const passwordControl = this.solicitudForm.get("password");

    if (this.firmaGuardada) {
      this.solicitudForm.patchValue({
        autocompletar_credencial: this.firmaGuardada,
      });
      passwordControl?.clearValidators();
      passwordControl?.setValue("******************");
    } else {
      this.solicitudForm.patchValue({
        autocompletar_credencial: this.firmaGuardada,
      });
      passwordControl?.setValidators([Validators.required]);
      passwordControl?.setValue("");
    }

    passwordControl?.updateValueAndValidity();
  }

  async existPassword() {
    this.firmaGuardada = this.scratch?.existPasswordSignbox ? true : false;

    this.ocultarFirmaGuardada = this.firmaGuardada;
    this.onChangeFirmaGuardada();
  }

  private checkDeviceType() {
    this.isDiviceType = this.isMobile() || this.isTablet();
  }

  isTablet(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

    const isIpad =
      /ipad/.test(userAgent) ||
      (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);

    const isAndroidTablet =
      /android/.test(userAgent) && !/mobile/.test(userAgent);

    const isTabletSize = window.innerWidth >= 768 && window.innerWidth <= 1366;

    return isIpad || isAndroidTablet || isTabletSize;
  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();

    return /iphone|ipod|android.*mobile|windows phone/i.test(userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile() && !this.isTablet();
  }
}
